import './FundamentalIcon.css';

export interface FundamentalIconProps {
  /** Valor del catálogo: clase Font Awesome (`fa-…`) o URL de imagen. */
  icon?: string;
  /** Clase CSS aplicada a la imagen cuando el icono es una URL. */
  imageClassName?: string;
  /** Icono Font Awesome usado cuando el catálogo no define ninguno. */
  fallbackIcon?: string;
}

/**
 * Resuelve el icono de un fundamental o de una actitud. El catálogo admite dos
 * formatos y esta lógica se repetía en cuatro lugares del dashboard.
 */
export function FundamentalIcon({
  icon,
  imageClassName = 'fund-icon-img',
  fallbackIcon = 'fa-circle',
}: FundamentalIconProps) {
  if (!icon) return <i className={`fas ${fallbackIcon}`} />;
  if (icon.startsWith('fa-')) return <i className={`fas ${icon}`} />;
  return <img src={icon} alt="" className={imageClassName} />;
}
